import React from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { WithCurrentUser } from "MODULES/session/decorators/withCurrentUser";
import { Field } from "redux-form";
import { AutoCompleteField } from "MODULES/shared/components/Forms";
import api from "APP_ROOT/api";
import IconText from "MODULES/shared/components/IconText/IconText";
import { PART_NUMBER } from "MODULES/parts/constants";

export function PartNumber({ search, part, onSelect, disabled, note }) {
  return (
    <Field
      name={PART_NUMBER}
      label="Part #"
      labelChildren={
        note ? (
          <IconText iconSize="fa-stack-1x" icon="fa-info-circle" note={note} />
        ) : null
      }
      placeholder="Type a part's number..."
      component={AutoCompleteField}
      search={search}
      selectedItem={part}
      formatItem={result => result && result.part_number}
      onItemSelected={i => i && onSelect(i)}
      disabled={disabled}
      required
    />
  );
}

PartNumber.propTypes = {
  note: T.string,
  part: T.shape({}),
  search: T.func.isRequired,
  onSelect: T.func.isRequired,
  disabled: T.bool,
  ...WithCurrentUser
};

const withProps = translateProps(() => ({
  search: filter =>
    api.parts
      .search({
        sellable: true,
        part_number: filter
      })
      .then(resp => resp.data.results)
}));

export default withProps(PartNumber);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/PartNumber.jsx